import type { RoomContext } from './RoomView';

/** Player sidebar: your teammates (with who is talking) and everyone else in the room. */
export function TeamPanel({
  ctx,
  publicSpeakers,
  teamSpeakers,
  teamRoom,
}: {
  ctx: RoomContext;
  publicSpeakers: string[];
  teamSpeakers: string[];
  teamRoom: 'none' | 'connecting' | 'connected';
}) {
  const { quiz, me } = ctx;
  const team = quiz.teams.find((t) => t.id === me?.teamId);
  const host = quiz.participants.find((p) => p.id === quiz.hostId);
  const mates = quiz.participants.filter((p) => p.teamId && p.teamId === me?.teamId);

  return (
    <section className="team-panel" aria-label="Your team">
      <div className="section-head">
        <h2>{team ? team.name : 'Your team'}</h2>
        {team && teamRoom === 'connecting' && <span className="muted">connecting…</span>}
      </div>
      {!team ? (
        <p className="muted">The quizmaster hasn't put you on a team yet. You can still talk to everyone.</p>
      ) : (
        <ul className="people">
          {mates.map((p) => {
            const whispering = teamSpeakers.includes(p.id);
            const talking = publicSpeakers.includes(p.id);
            return (
              <li key={p.id} className={`person${p.online ? '' : ' offline'}`}>
                <span className={`avatar${whispering ? ' whispering' : talking ? ' talking' : ''}`} style={{ ['--c' as string]: team.color }}>
                  {p.name.slice(0, 1).toUpperCase()}
                </span>
                <span className="person-name">
                  {p.name}
                  {p.id === me?.id && <span className="muted"> (you)</span>}
                </span>
                <span className="person-state">{!p.online ? 'away' : whispering ? 'whispering' : talking ? 'talking' : ''}</span>
              </li>
            );
          })}
        </ul>
      )}
      {host && (
        <div className="qm-line">
          <span className={`avatar qm${publicSpeakers.includes(host.id) ? ' talking' : ''}`}>{host.name.slice(0, 1).toUpperCase()}</span>
          <span className="person-name">{host.name}</span>
          <span className="person-state">quizmaster</span>
        </div>
      )}
    </section>
  );
}
